import TypeLoad from './TypeLoad'

export default TypeLoad
